import React from 'react';
import classNames from '~/components/util/classNames';
import isEmpty from 'lodash/isEmpty';
import InputMask from 'react-input-mask';
// import CurrencyInput from 'react-currency-input';

function addCommas(nStr) {
    if (!nStr) return '';
    nStr += '';
    var comma = /,/g;
    nStr = nStr.replace(comma,'');
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

function FormInput(props) {
    let {
        path,
        index,
        placeholder = '',
        autoComplete = '',
        value = '',
        error = '',
        type = 'text',
        inputClassName = 'form-control',
        readOnly = false,
        onChange,
        onBlur,
        validator,
        min = -99999,
        minLength = null,
        maxLength = null,
        max = '',
        mask = '',
        refProp
    } = props;

    const hasError = !isEmpty(error);
    const hasErrorClass = hasError ? 'is-invalid' : '';
    const inputClasses = classNames('form-input',hasErrorClass, inputClassName);
    let inputGroupText = '';
    if (type == 'percent') {
        inputGroupText = '%';
    } else if (type == 'currency') {
        inputGroupText = '$';
    }

    let extraProps = {};
    if (min !== -99999)
        extraProps = {
            min
        };
    
    let pattern;
    if (type == 'number') {
        min = 0;
        pattern = '[0-9]*';
    }
    return (
        <React.Fragment>
            { !mask && 
            <div className="input-group">
                <div className="flex items-center justify-center">
                    { ['currency', 'percent'].includes(type) &&
                        <span className="self-end mb-1 mr-2">{inputGroupText}</span>
                    }
                    <input
                        id={path}
                        name={path}
                        key={index}
                        max={max}
                        min={min}
                        minLength={minLength}
                        maxLength={maxLength}
                        type={type}
                        pattern={pattern}
                        disabled={readOnly}
                        readOnly={readOnly}
                        className={inputClasses}
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        value={['decimal', 'currency'].includes(type) ? addCommas(value): value}
                        onChange={event => {
                            if (!onChange) return;
                            if (['number', 'decimal', 'currency'].includes(type) && event.target.value == '') 
                                return onChange(null, path, index);
                            
                            if (type == 'number')
                                return onChange(event.target.value.replace(/[^0-9]/g, ''), path, index);
                            if (type == 'decimal') {
                                let dSplit = event.target.value.split('.');
                                if (dSplit.length == 2 && dSplit[1].length > 2) {
                                    return onChange(value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
                                }
                                return onChange(event.target.value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
                            }
                            if (type == 'currency') {
                                let dSplit = event.target.value.split('.');
                                if (dSplit.length == 2 && dSplit[1].length > 2) {
                                    return onChange(value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
                                }
                                return onChange(event.target.value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
                            }
                            onChange(event.target.value, path, index);
                        }}
                        onBlur={event => onBlur && onBlur(event.target.value, path, validator)}
                        {...extraProps}
                        ref={refProp}
                    />
                </div>
            </div>
            }
            
            { mask &&
            <InputMask 
                id={path}
                name={path}
                className={inputClasses}
                placeholder={placeholder}
                mask={mask} 
                readOnly={readOnly}
                maskChar=" "
                value={value}
                onChange={event => onChange && onChange(event.target.value, path, index)}
            />
            }
        </React.Fragment>
    );
}



export default FormInput;